import {Route, Routes} from "react-router-dom";

import DriverListScreen from "screens/App/CRM/Driver/DriverListScreen";
import DriverInfoScreen from "screens/App/CRM/Driver/DriverInfoScreen";
import DriverDetailScreen from "screens/App/CRM/Driver/DriverDetailScreen";
import DriverEditScreen from "screens/App/CRM/Driver/DriverEditScreen";
import DriverCreateScreen from "screens/App/CRM/Driver/DriverCreateScreen";
import DriverLicenceListScreen from "screens/App/CRM/Driver/driverComponents/DriverLicenceListScreen";

import NotFoundScreen from "screens/NotFoundScreen";

const DriverRouter = () => {
    return (
        <Routes>
            <Route path= "list" element={<DriverListScreen />} />
            <Route path= "create" element={<DriverCreateScreen />} />
            <Route path= "driverLicence" element={<DriverLicenceListScreen />} />
            <Route path= ":id/detail" element={<DriverDetailScreen />} />
            <Route path= ":id/edit" element={<DriverEditScreen />} />
            <Route path= "info" element={<DriverInfoScreen />} />
            <Route path= "*" element={<NotFoundScreen />} />
        </Routes>
    );
};

export default DriverRouter;